import { render, staticRenderFns } from "./ModalAddDetail.vue?vue&type=template&id=2fefb838&"
import script from "./ModalAddDetail.vue?vue&type=script&lang=js&"
export * from "./ModalAddDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports